export default __webpack_public_path__ + "static/media/resumen_de_historia_clinica_ampliado.41a10587.pdf";